import React from 'react';
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/lib/Async'
// https://react-select.com/async#loading-asynchronously
import client from '../../helpers/client'
import CustomOption from './CustomOption'
import './index.scss'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    fontSize: 18,
    paddingLeft: 10
  })
}

const deserializeBackdrop = (backdrop) => {
  if(backdrop && backdrop.id && backdrop.attributes) {
    return {
      value: backdrop.id,
      label: backdrop.attributes.name,
      attributes: backdrop.attributes
    }
  }
  else {
    return null
  }
}

const deserializeBackdrops = (serializedBackdrops) => {
  return serializedBackdrops.map(backdrop => deserializeBackdrop(backdrop)).filter(backdrop => backdrop)
}



class BackdropDropdown extends React.Component {
  static propTypes = {
    backdrops: PropTypes.array,
    inputId: PropTypes.string,
    selected: PropTypes.object,
    apiKey: PropTypes.string.isRequired,
    connectionId: PropTypes.string
  }

  static defaultProps = {
    backdrops: []
  }

  state = {
    selectedOption: deserializeBackdrop(this.props.selected),
    currentValue: ""
  }

  componentDidMount() {
    const { inputId } = this.props

    if(inputId) {
      this.input = document.getElementById(inputId)
      this.syncHtmlInput()
    }
  }

  handleInputChange = (currentValue) => {
    this.setState({ currentValue })
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () => this.syncHtmlInput())

  }

  syncHtmlInput() {
    const { selectedOption } = this.state

    if(this.input) {
      if(selectedOption) {
        this.input.value = selectedOption.value
      }
      else {
        this.input.value = ""
      }
    }
  }

  handleLoadOptions = (inputValue, callback) => {
    const { apiKey, connectionId } = this.props
    const { currentValue } = this.state

    client.get(`/api/v1/photobooth_backgrounds.json?api_key=${apiKey}&text=${currentValue}&order=name&only_widget_visible=false`)
      .then(response => {
        const options = deserializeBackdrops(response.data.data)
        callback(options)
      })
      .catch(error => {
        const { data, status } = error.response
        const { errors } = data
        const errorMessage = status === 422 ? errors.join(", ") : "Error contacting server"
        alert(errorMessage)
      })
  }



  render() {
    const { backdrops } = this.props
    const { selectedOption, currentValue } = this.state;

    return (
      <AsyncSelect
        cacheOptions
        name={"backdrop_id"}
        loadOptions={this.handleLoadOptions}
        components={{ Option: CustomOption }}
        onInputChange={this.handleInputChange}
        onChange={this.handleChange}
        styles={customStyles}
        placeholder="Start typing..."
        noOptionsMessage={() => currentValue ? "Unable to find any matching backdrops" : "Start typing to search for backdrops"}
        defaultOptions={deserializeBackdrops(backdrops)}
        value={selectedOption}
        isClearable={true}
      />
    );
  }
}

export default BackdropDropdown
